import {useEffect, useState} from "react";
import {getItems} from "../services/api";
import { Link } from "react-router-dom";
import {NavLink} from "reactstrap";

export default function ListItems() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        getItems()
            .then(apiItems => {
                setItems(apiItems)
            })
            .catch(ex => {
                console.log("Error getting items: ", ex)
            })
    }, []);
    
    return (
        <>
            {items && 
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Last Purchase</th>
                        <th>Lifespan</th>
                        <th>Score</th>
                    </tr>
                    </thead>
                    <tbody>
                    {items.map(i => {
                        return (
                            <tr key={i.itemId}>
                                <td><Link to={`/items/${i.itemId}/edit`}>{i.name}</Link></td>
                                <td>{new Date(i.purchaseDate).toLocaleDateString()}</td>
                                <td>{i.lifespan}</td>
                                <td>{i.percentage.toFixed(2)}</td>
                            </tr>
                        )
                        })}
                    </tbody>
                </table>}
                <div className="mt-3 col-md-3">
                    <Link to={"/items/new/edit"} className="btn btn-primary">Add Item</Link>
                </div>
        </>
    )
}